
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';
import IconChip from '@/core/components/IconChip.vue';
import TooltipWithTextInput from '@/core/components/TooltipWithTextInput.vue';
import { LoanFI } from '@/loan/types/loan-fi';
import { LoanUpdateLoanRequest } from '@/loan/types/loan-update-loan-request';
import { LoanAPIService } from '@/loan/services/api';
import { namespace } from 'vuex-class';

const loanNamespace = namespace('loan');

@Component({
	components: {
		IconChip,
		TooltipWithTextInput,
	},
})
export default class LoanSummaryFIIcon extends Vue {
	@loanNamespace.Action('getAndSetLoanDetails')
	public getAndSetLoanDetails!: (loanId: string) => void;

	@Prop({ required: true })
	public description!: string;

	@Prop({ required: true })
	public loanId!: string;

	@Prop({ required: true })
	public fi!: LoanFI;

	public descriptionSync = '';

	public isLoading: boolean = false;

	public isShown: boolean = false;

	get fiIcon(): string {
		return this.fi.iconData;
	}

	get fiName(): string {
		return this.fi.name;
	}

	get fiPhone(): string {
		return this.fi.contactPhone;
	}

	public tooltipClosed(): void {
		this.isShown = false;
	}

	public async onDescriptionChange(description: string): Promise<void> {
		this.isLoading = true;

		const request: LoanUpdateLoanRequest = {
			description,
		};

		try {
			await LoanAPIService.updateLoan(this.loanId, request);
			await this.getAndSetLoanDetails(this.loanId);
		} catch (error) {
			console.error(error);
		} finally {
			this.isLoading = false;
			this.isShown = false;
		}
	}
}
